import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface StepFormData {
  [key: string]: any;
}

interface TransportState {
  applicationId: string | null;
  formData: {
    step1: StepFormData;
    step2: StepFormData;
    step3: StepFormData;
  };
}

interface SaveFormDataPayload {
  applicationId: string;
  formData: StepFormData;
  step: 'step1' | 'step2' | 'step3';
}

const initialState: TransportState = {
  applicationId: null,
  formData: {
    step1: {},
    step2: {},
    step3: {},
  },
};

export const transportSlice = createSlice({
  name: 'transport',
  initialState,
  reducers: {
    saveTransportForm: (state, action: PayloadAction<SaveFormDataPayload>) => {
      const { applicationId, formData, step } = action.payload;
      state.applicationId = applicationId;
      state.formData[step] = formData;
    },
    clearTransportForm: (state) => {
      state.applicationId = null;
      state.formData = { step1: {}, step2: {}, step3: {} };
    },
  },
});

export const { saveTransportForm, clearTransportForm } = transportSlice.actions;
export default transportSlice.reducer;
